import './polyfills'

import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { createApp } from 'vue'

import * as Sentry from "@sentry/vue"

// B 16.09.2026: PWA disabled for now
// import { registerSW } from 'virtual:pwa-register'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Create vue app
const app = createApp(App)

// B 16.09.2026: PWA disabled for now
// registerSW({ immediate: true })

// Register plugins
registerPlugins(app)

if (import.meta.env.VITE_SENTRY_ENABLED && import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  //const Sentry = await import('@sentry/vue')

  Sentry.init({
    app,
    dsn: "https://ad5b5fcce06580523594f503f1968db7@o4510269005365248.ingest.de.sentry.io/4510269029875792",

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,

    // Session Replay
    integrations: [
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,

    // Logs
    enableLogs: true,
  })
}



// Mount vue app
app.mount('#app')

